import React, { useMemo } from 'react';
import { isNull } from 'lodash';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import DayJs from 'utils/Dayjs';

// Temporary nv mapping
const nv = ['nv', 'n/v', 'Nv', 'NV', 'N/V', 'N/v'];

const Mark = ({ to, mark, onClick, className }) => {
	// Concat classnames for mark
	const cls = classnames(
		'relative w-7 h-7 flex items-center justify-center font-bold text-base text-center border rounded-lg',
		onClick && 'cursor-pointer',
		className
	);
	
	// Return link component if to prop is passed
	if (to) {
		return (
			<Link to={to} className={cls}>
				{mark}
			</Link>
		);
	}

	// Return div component otherwise
	return (
		<div to={to} className={cls} onClick={onClick}>
			{mark}
		</div>
	);
};

export const DefaultMark = ({ to, take, onClick, className }) => {
	// Get mark's types
	const types = useMemo(() => ({
		unavailable: take.state === 'assigned' && DayJs().isBefore(take.startDate),
		active: take.state === 'active',
		finished: take.state === 'finished',
		reviewed: take.state === 'reviewed',
		transfered: take.state === 'reviewed' && isNull(take.startedAt),
		overdue: take.state === 'assigned' && DayJs().isAfter(take.endDate),
		failed: take.state === 'reviewed' && take.mark !== 0 && take.mark < 4
	}), [take]);

	// Create className for mark
	const cls = classnames(
		'relative w-7 h-7 flex items-center justify-center font-bold text-base text-center border rounded-lg',
		types.active && 'text-neutral-700 border-sky-500 dark:text-neutral-200 dark:border-sky-500 after:absolute after:w-5 after:h-5 after:rounded-md after:border after:border-sky-500 after:animate-ping',
		types.finished && 'text-neutral-700 border-amber-500 dark:text-neutral-200 dark:border-amber-500',
		types.reviewed && 'text-neutral-700 border-neutral-200 dark:text-neutral-200 dark:border-neutral-500',
		types.transfered && 'text-neutral-700 border-emerald-500 dark:text-neutral-200 dark:border-emerald-500',
		types.overdue && 'text-rose-500 border-rose-500 dark:text-rose-500 dark:border-rose-500 text-xs',
		types.failed && 'text-rose-500 border-rose-500 dark:text-rose-500 dark:border-rose-500',
		(!types.active && !types.finished && !types.reviewed && !types.transfered && !types.overdue && !types.failed)
		&& 'text-neutral-700 border-neutral-200 dark:text-neutral-200 dark:border-neutral-500',
		onClick && 'cursor-pointer',
		className
	);

	// Return link if passed to
	if (to) return (
		<Link to={to} className={cls}>
			{types?.overdue ? 'nv' : take?.mark}
		</Link>
	);
	
	// Return normal component
	return (
		<div className={cls} onClick={onClick}>
			{types?.overdue ? 'nv' : take?.mark}
		</div>
	);
};

export const AverageMark = ({ mark, className }) => {
	// Create className for mark
	const cls = classnames(
		'relative w-7 h-7 flex items-center justify-center font-bold text-sm text-center border rounded-lg',
		'text-neutral-700 border-neutral-200 dark:text-neutral-200 dark:border-neutral-500',
		className
	);
	
	return (
		<div className={cls}>
			{mark}
		</div>
	);
};

export const FinalMark = ({ to, mark, onClick, className }) => {
	// Create className for mark
	const cls = classnames(
		'relative w-7 h-7 flex items-center justify-center font-bold text-base text-center border rounded-lg',
		(mark?.type === 'middle' && !nv.includes(mark?.mark)) && 'text-neutral-700 border-neutral-400 dark:text-neutral-200 dark:border-neutral-400',
		(mark?.type === 'final' && !nv.includes(mark?.mark)) && 'text-neutral-700 border-neutral-700 dark:text-neutral-200 dark:border-neutral-200',
		(mark?.type === 'transferred' && !nv.includes(mark?.mark)) && 'text-neutral-700 border-emerald-500 dark:text-neutral-200 dark:border-emerald-500',
		nv.includes(mark?.mark) && 'text-rose-500 border-rose-500 dark:text-rose-500 dark:border-rose-500 text-xs',
		onClick && 'cursor-pointer',
		className
	);

	// Return link if passed to
	if (to) return (
		<Link to={to} className={cls}>
			{mark?.mark}
		</Link>
	);

	// Return normal component
	return (
		<div className={cls} onClick={onClick}>
			{mark?.mark}
		</div>
	);
};

export default Mark;